import React, {useEffect, useState} from 'react'
import {css} from '@emotion/core'
import {getExtensionPromoCtaUrl} from '../../util/extensionPromoCtaUrl'
import {isFirefox} from '../../util/userAgent'
import InstructionalModal from './InstructionalModal'

const BROWSER_EXTENSION_LINK_KEY = `browser_extension`

const HamburgerLink = ({linkData, themeStyles, lang = `en`, setShowMenu}) => {
    const {name, url, iconProperty} = linkData
    const isExtensionLink = url === BROWSER_EXTENSION_LINK_KEY

    const [href, setHref] = useState(url)
    const [isFirefoxBrowser, setIsFirefoxBrowser] = useState(false)
    const [showInstructionalModal, setShowInstructionalModal] = useState(false)

    useEffect(() => {
        setIsFirefoxBrowser(isFirefox())
    }, [])

    useEffect(() => {
        if (!isExtensionLink) {
            return
        }
        const nextHref = getExtensionPromoCtaUrl(lang) ?? url
        setHref(nextHref)
    }, [url, lang, isExtensionLink])

    const isFirefoxExtensionLink = isExtensionLink && isFirefoxBrowser

    return (
        <a
            href={href}
            target={isFirefoxExtensionLink ? undefined : `_blank`}
            rel={isFirefoxExtensionLink ? undefined : `noopener noreferrer`}
            css={css`
                text-decoration: none;
                @media (max-width: 990px) {
                    ${url === BROWSER_EXTENSION_LINK_KEY && `display: none;`}
                }
            `}
            onClick={() => {
                if (isFirefoxExtensionLink) {
                    setShowInstructionalModal(true)
                    setShowMenu(false)
                }
            }}
        >
            {showInstructionalModal && (
                <InstructionalModal lang={lang} setShowInstructionalModal={setShowInstructionalModal} />
            )}
            <div
                css={css`
                    display: flex;
                    gap: 9px;
                    align-items: center;
                `}
            >
                {iconProperty && (
                    <div
                        css={css`
                            width: 20px;
                            height: 20px;
                            background: url(${themeStyles?.menu?.[iconProperty]}) no-repeat center center;
                            background-size: contain;
                        `}
                    />
                )}
                <p
                    css={css`
                        font-size: 16px;
                        color: ${themeStyles.primaryTextColor};
                    `}
                >
                    {name}
                </p>
            </div>
        </a>
    )
}

export default HamburgerLink
